"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTemplateEnum = void 0;
var FileTemplateEnum;
(function (FileTemplateEnum) {
    FileTemplateEnum["DATA_UPLOAD_SPREADSHEET"] = "DATA_UPLOAD_SPREADSHEET";
})(FileTemplateEnum || (exports.FileTemplateEnum = FileTemplateEnum = {}));
